import React, { useImperativeHandle, useRef } from 'react';
import { ArrayHelpers, FieldArray } from 'formik';
import { createLiability as createItem } from '../../../utils/liabilities';
import { Props } from './LiabilitiesList.types';
import LiabilityItem from '../LiabilityItem/LiabilityItem';
import { Columns, Select } from 'modules/af_cm_ui_kit/components';
import { Option } from 'shared/interface/globalInterface';

type ItemWrapperInterface = {
  addLiability: (type: string) => void;
  deleteItem: Function;
};

const FieldArrayChild = React.forwardRef(
  ({ items, prefix, arrayHelpers }: { items: any; prefix: string; arrayHelpers: ArrayHelpers }, ref) => {
    const addLiability = (type: string) => {
      arrayHelpers.push(createItem(type));
    };

    const deleteItem = (index: number) => {
      return () => {
        arrayHelpers.remove(index);
      };
    };

    useImperativeHandle(
      ref,
      (): ItemWrapperInterface => ({
        addLiability,
        deleteItem,
      }),
    );

    return items.map((item: any, index: number) => (
      <LiabilityItem
        key={`liability-item-${index}`}
        prefix={`${prefix}.${index}`}
        onDelete={deleteItem(index)}
        item={item}
      />
    ));
  },
);

const LiabilitiesList: React.FC<Props> = ({ items, prefix, creditCommitments }) => {
  const itemsRef = useRef<ItemWrapperInterface>();

  const handleSelectClick = (option: Option) => {
    if (itemsRef.current) {
      itemsRef.current.addLiability(option.value);
    }
  };

  return (
    <>
      <Columns spacing={4}>
        <Select
          options={creditCommitments}
          value={''}
          handleClick={handleSelectClick}
          placeholder={'Add credit commitments'}
          required
        />
        <></>
      </Columns>

      <FieldArray
        name={prefix}
        render={(arrayHelpers) => {
          return <FieldArrayChild ref={itemsRef} arrayHelpers={arrayHelpers} items={items} prefix={prefix} />;
        }}
      />
    </>
  );
};

export default LiabilitiesList;
